import { Workbox } from "workbox-window";
let wb;
if ("serviceWorker" in navigator) {
  wb = new Workbox(`${import.meta.env.BASE_URL}service-worker.js`);
  wb.addEventListener("controlling", (event) => {
    if (event.isUpdate) {
      window.location.reload();
    }
  });

  wb.addEventListener("error", (event) => {
    console.error("Service worker error:", event);
  });

  wb.register().catch((error) => console.warn("Service worker registration failed:", error));
} else {
  wb = null;
}
export default wb;
